import $ from 'wee-dom';
import $events from 'wee-events';
import { RouteHandler } from 'wee-routes';

const hiddenClass = '-is-hidden';

function openCommentForm(element) {
	let $targetForm = $(element).parent().siblings('.js-comment-form');

	if ( $targetForm.hasClass( hiddenClass ) ) {
		$targetForm.removeClass( hiddenClass );
	}
}

export default new RouteHandler({
	init() {
		if ($('.js-wallpaper-sizes').length) {
			$events.on({
				'.js-wallpaper-sizes': {
					click(e, el) {
						$(el).toggleClass('-open');
					}
				}
			});
		}

		$events.on({
			'.js-comment-reply': {
				click(e, el) {
					openCommentForm(el);
				},
				keypress(e, el) {
					if (e.keyCode === 13) {
						openCommentForm(el);
					} else if (e.keyCode === 9) {
						openCommentForm(el);
					}
				}
			}
		});
	}
});